import { ProjectId } from "@taskin-code/contracts";
import { createFileRoute } from "@tanstack/react-router";

import { SnoozedThreadsView } from "~/components/snoozed/SnoozedThreadsView";

function FocusedProjectSnoozedRoute() {
  const { projectId } = Route.useParams();
  return <SnoozedThreadsView fixedProjectId={ProjectId.makeUnsafe(projectId)} />;
}

export const Route = createFileRoute("/_chat/projects/$projectId/snoozed")({
  component: FocusedProjectSnoozedRoute,
});
